import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const breadcrumbsV2PaddingToMarginMigration: PropsMigration = {
  mode: 'props',
  description: 'Migrate breadcrumbs external spacing from offset.padding to offset.margin',
  run: (props: PartialPropsOf<'breadcrumbs'>): void => {
    const offset = props.style?.offset;
    if (offset?.padding === undefined) {
      return;
    }
    offset.margin = offset.padding;
    delete offset.padding;
  },
};
